module.exports = "/_next/static/images/Personalization-sm-03d922a4064c0dc95064cdcf772dc3a5.png";